import { render, staticRenderFns } from "./specialistTable.vue?vue&type=template&id=4ab9ee80"
import script from "./specialistTable.vue?vue&type=script&lang=js"
export * from "./specialistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports